// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/" + {"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] + ".js";
};